import axios from "axios";

import {
  ResponseList,
  ResponseItem,
  ResponseRemove,
} from "../../models/clientModels/interfaces/Response";
import * as Params from "../../models/clientModels/interfaces/apiParams";
import {BoardPostListParams, KPBoard} from "../../models/serverModels/board/KPBoard";

const Board = axios.create({
  baseURL: "/api",
});

export const getList = async (params: {token: string}): Promise<ResponseList<KPBoard>> =>
  Board({
    url: "/BoardList",
    method: "get",
    params,
  }).then((res) => res.data);

export const getItem = async (params: Params.GetItem): Promise<ResponseItem<KPBoard>> =>
  Board({
    url: `/Board/${params.id}`,
    method: "get",
    params,
  }).then((res) => res.data);

export const create = async (params: Params.Create<KPBoard>): Promise<ResponseItem<KPBoard>> =>
  Board({
    url: `/Board`,
    method: "post",
    data: params,
  }).then((res) => res.data);

export const remove = async (params: Params.Remove): Promise<ResponseRemove> =>
  Board({
    url: `/Board/${params.id}`,
    method: "delete",
    data: params,
  }).then((res) => res.data);

export const update = async (params: Params.Update<KPBoard>): Promise<ResponseItem<KPBoard>> =>
  Board({
    url: `/Board/${params.id}`,
    method: "put",
    data: params,
  }).then((res) => res.data);

export const getMainBoard = async (params: {token: string}): Promise<ResponseList<KPBoard>> =>
  Board({
    url: "/MainBoardList",
    method: "get",
    params,
  }).then((res) => res.data);

export const getBoardWithPosts = async (
  params: BoardPostListParams
): Promise<ResponseItem<KPBoard>> =>
  Board({
    url: "/BoardWithPosts",
    method: "get",
    params,
  }).then((res) => res.data);
